import { interceptPropertyChange, InterceptPropertyChangeCallback } from './property-helpers';

/**
 * @name interceptValueChange
 *
 * Intercepts value changes on Input and TextArea elements and allows to run a custom callback before the value is changed.
 *
 * @example
 * interceptValueChange(inputEl, (newValue: any) => {
 *   console.log('value changed to ' + newValue);
 * });
 */
export const interceptValueChange = (
    obj: HTMLInputElement | HTMLTextAreaElement,
    callbackFn: InterceptPropertyChangeCallback<HTMLInputElement['value'] | HTMLTextAreaElement['value']>
): void => {
    interceptPropertyChange(obj, 'value', callbackFn);
};

/**
 * @name interceptCheckedChange
 *
 * Intercepts checked changes on Input elements and allows to run a custom callback before checked is changed.
 *
 * @example
 * interceptCheckedChange(inputEl, (newState: any) => {
 *   console.log('checked changed to ' + newState);
 * });
 */
export const interceptCheckedChange = (
    obj: HTMLInputElement,
    callbackFn: InterceptPropertyChangeCallback<HTMLInputElement['checked']>
): void => {
    interceptPropertyChange(obj, 'checked', callbackFn);
};
